"use client";

import React from "react";
import { SocketProvider } from "@/providers/SocketProvider";
import { IndicatorsProvider } from "@/providers/IndicatorsProvider";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SocketProvider>
      <IndicatorsProvider>{children}</IndicatorsProvider>
    </SocketProvider>
  );
}
